import { useIntl } from '@capsicum/common';
import { Button, Goat, ModalService } from '@capsicum/common-web';
import { useCallback } from 'react';
import styled from 'styled-components';

export const usePreventUSModal = (UScontactUSLink: string, onDismiss?: () => void) => {
	const { $t } = useIntl();

	const openSociosUS = useCallback(() => {
		window.open(UScontactUSLink, '_blank');
	}, [UScontactUSLink]);

	const showPreventUSModal = useCallback(
		() =>
			ModalService.addModal({
				detached: true,
				isClosable: !onDismiss,
				onDismiss,
				renderComponent: ({ close }) => {
					const onButtonPress = () => {
						close();
						openSociosUS();
					};

					return (
						<Goat image="alert" testID="goatScreen-register-modalPreventUS" withoutTitleContainer>
							<S.TextWrapper>
								<S.Title>{$t('auth.preventUSCountryTitle')}</S.Title>
								<S.ModalText>{$t('auth.preventUSCountryMessagePart1')}</S.ModalText>
								<S.ModalText>{$t('auth.preventUSCountryMessagePart2')}</S.ModalText>
							</S.TextWrapper>
							<S.ButtonWrapper>
								<Button
									color="brand"
									testID="preventUSA-contactUs-button"
									text={$t('auth.preventUSCountryButton')}
									onClick={onButtonPress}
								/>
							</S.ButtonWrapper>
						</Goat>
					);
				}
			}),
		[$t, onDismiss, openSociosUS]
	);

	return {
		showPreventUSModal
	};
};
namespace S {
	export const TextWrapper = styled.div`
		text-align: center;
		margin-top: ${({ theme }) => theme.spacings.large};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;

	export const Title = styled.p`
		${({ theme }) => theme.fonts.headings.title6};
		margin-bottom: ${({ theme }) => theme.spacings.xxsmall};
	`;

	export const ModalText = styled.p`
		${({ theme }) => theme.fonts.text.text3};
		margin-top: ${({ theme }) => theme.spacings.xsmall};
		margin: 0;
	`;

	export const ButtonWrapper = styled.div`
		display: flex;
		flex-direction: 'row';
		justify-content: center;
		align-items: center;
		margin-top: ${({ theme }) => theme.spacings.large};
		gap: ${({ theme }) => theme.spacings.medium};
	`;
}
